(function () {
  'use strict';
  if (window.LmbCartIntegrity) return;
  var configNode = document.getElementById('lmb-cart-integrity-data');
  if (!configNode) return;
  var config = JSON.parse(configNode.textContent);
  var strings = config.strings;
  var routeRoot = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var busy = false;
  var approvedClicks = new WeakSet();
  var approvedForms = new WeakSet();
  var blockedButtons = new Map();

  var maxSamples = Number(config.maxSamples) || 4;
  var sampleProductId = String(config.sampleProductId || '');
  var sampleVariantIds = new Set((config.sampleVariantIds || []).map(String));

  function isSample(item) {
    var props = item.properties || {};
    return (sampleProductId && String(item.product_id || '') === sampleProductId)
      || sampleVariantIds.has(String(item.variant_id || item.id || '').split(':')[0])
      || props['_Sample Request'] === 'Free Fabric Sample';
  }

  function sampleCount(cart) {
    return (cart.items || []).reduce(function (total, item) {
      if (!isSample(item)) return total;
      var props = item.properties || {};
      var colours = Object.keys(props).filter(function (key) {
        return /^Sample\s+\d+$/.test(key) && String(props[key] || '').trim();
      }).length;
      var quantity = item.quantity == null ? 1 : Number(item.quantity);
      return total + Math.max(1, colours) * Math.max(0, quantity || 0);
    }, 0);
  }

  function projectSampleCart(cart, action, payload) {
    var items = cart.items.map(function (item) {
      return { ...item, properties: { ...(item.properties || {}) } };
    });
    function findItem(id) {
      return items.find(function (item) { return item.key === String(id); })
        || items.find(function (item) { return String(item.variant_id || item.id) === String(id); });
    }
    if (action === 'add') {
      (Array.isArray(payload.items) ? payload.items : [payload]).forEach(function (item) {
        items.push({ ...item, quantity: item.quantity == null ? 1 : item.quantity });
      });
    } else if (action === 'change') {
      var item = payload.line ? items[Number(payload.line) - 1] : findItem(payload.id);
      if (item) {
        if (payload.quantity != null) item.quantity = Number(payload.quantity);
        if (payload.properties) item.properties = { ...payload.properties };
      }
    } else if (action === 'update') {
      var updates = payload.updates || {};
      if (Array.isArray(updates)) {
        updates.forEach(function (quantity, index) { if (items[index]) items[index].quantity = Number(quantity); });
      } else {
        Object.keys(updates).forEach(function (id) {
          var item = findItem(id);
          if (item) item.quantity = Number(updates[id]);
        });
      }
    } else if (action === 'clear') items = [];
    return { items: items };
  }

  async function cartPayload(input, init) {
    var body = init && init.body;
    if (body == null && typeof Request !== 'undefined' && input instanceof Request) body = await input.clone().text();
    if (body == null) return {};
    if (typeof Blob !== 'undefined' && body instanceof Blob) body = await body.text();
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (error) { body = new URLSearchParams(body); }
    }
    if (!(body instanceof FormData) && !(body instanceof URLSearchParams)) throw new Error(strings.unavailable);
    var data = {}, additions = [], updates = null;
    body.forEach(function (value, name) {
      var match;
      if (name === 'id' || name === 'quantity' || name === 'line') data[name] = value;
      else if (name === 'updates[]') {
        if (!Array.isArray(updates)) updates = [];
        updates.push(value);
      } else if ((match = /^updates\[([^\]]+)\]$/.exec(name))) {
        if (!updates) updates = Object.create(null);
        updates[match[1]] = value;
      } else if ((match = /^properties\[([^\]]+)\]$/.exec(name))) {
        if (!data.properties) data.properties = Object.create(null);
        data.properties[match[1]] = value;
      } else if ((match = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(name))) {
        if (!additions[match[1]]) additions[match[1]] = {};
        additions[match[1]][match[2]] = value;
      } else if ((match = /^items\[(\d+)\]\[properties\]\[([^\]]+)\]$/.exec(name))) {
        if (!additions[match[1]]) additions[match[1]] = {};
        if (!additions[match[1]].properties) additions[match[1]].properties = Object.create(null);
        additions[match[1]].properties[match[2]] = value;
      }
    });
    if (additions.length) data.items = additions.filter(Boolean);
    if (updates) data.updates = updates;
    return data;
  }

  function installSampleLimit() {
    var previousFetch = window.fetch.bind(window);
    var queue = Promise.resolve();
    window.fetch = function (input, init) {
      var url;
      try { url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, window.location.origin); }
      catch (error) { return previousFetch(input, init); }
      var match = /\/cart\/(add|change|update)(?:\.js)?\/?$/.exec(url.pathname);
      var method = String(init?.method || input?.method || 'GET').toUpperCase();
      if (url.origin !== window.location.origin || !match || method === 'GET' || method === 'HEAD') return previousFetch(input, init);
      var action = match[1];
      var run = async function () {
        try {
          var payload = await cartPayload(input, init);
          var additions = Array.isArray(payload.items) ? payload.items : [payload];
          if (action === 'add' && !additions.some(isSample)) return previousFetch(input, init);
          var response = await previousFetch(routeRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(strings.unavailable);
          var cart = await response.json();
          if (!Array.isArray(cart.items)) throw new Error(strings.unavailable);
          var proposed = sampleCount(projectSampleCart(cart, action, payload));
          if (proposed > maxSamples && proposed > sampleCount(cart)) {
            return new Response(JSON.stringify({ status: 422, message: strings.sampleLimit, description: strings.sampleLimit, errors: strings.sampleLimit }), { status: 422, headers: { 'Content-Type': 'application/json' } });
          }
          var result = await previousFetch(input, init);
          if (result.ok && action !== 'add') {
            result.clone().json().then(function (updated) {
              if (Array.isArray(updated.items) && analyse(updated).valid) {
                controls(false);
                document.querySelectorAll('[data-lmb-cart-integrity-status]').forEach(function (node) { node.remove(); });
              }
            }).catch(function () {});
          }
          return result;
        } catch (error) {
          return new Response(JSON.stringify({ status: 422, message: strings.unavailable, description: strings.unavailable, errors: strings.unavailable }), { status: 422, headers: { 'Content-Type': 'application/json' } });
        }
      };
      var next = queue.then(run, run);
      queue = next.then(function () {}, function () {});
      return next;
    };
  }


  function analyse(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error(strings.unavailable);
    var parents = new Map();
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      if (props._bundle_id && !props._parent_product) {
        var group = parents.get(props._bundle_id) || [];
        group.push(item);
        parents.set(props._bundle_id, group);
      }
    });
    var orphaned = [], mismatched = [], ambiguous = [];
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      if (!props._bundle_id || !props._parent_product) return;
      var group = parents.get(props._bundle_id) || [];
      if (!group.length) orphaned.push(item);
      else if (group.length !== 1) ambiguous.push(item);
      else if (Number(item.quantity) !== Number(group[0].quantity)) {
        mismatched.push({ item: item, quantity: Number(group[0].quantity) });
      }
    });
    var samples = sampleCount(cart);
    return { orphaned: orphaned, mismatched: mismatched, ambiguous: ambiguous, samples: samples,
      valid: !orphaned.length && !mismatched.length && !ambiguous.length && samples <= maxSamples };
  }

  function controls(block) {
    document.querySelectorAll('button[name="checkout"], input[type="submit"][name="checkout"]').forEach(function (button) {
      if (block) {
        if (!blockedButtons.has(button)) blockedButtons.set(button, button.disabled);
        button.disabled = true;
      } else if (blockedButtons.has(button)) {
        button.disabled = blockedButtons.get(button);
        blockedButtons.delete(button);
      }
    });
    document.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart').forEach(function (node) {
      if (block && !node.hidden) { node.hidden = true; node.dataset.lmbIntegrityHidden = 'true'; }
      else if (!block && node.dataset.lmbIntegrityHidden === 'true') { node.hidden = false; delete node.dataset.lmbIntegrityHidden; }
    });
    if (!block) document.getElementById('lmb-cart-integrity-server-block')?.remove();
  }

  function showProblem(message, issue, trigger) {
    controls(true);
    var scope = trigger?.closest('cart-drawer') || document.querySelector('#main-cart-items') || document.querySelector('cart-drawer.active') || document.body;
    var status = scope.querySelector('[data-lmb-cart-integrity-status]');
    if (!status) {
      status = document.createElement('div');
      status.className = 'lmb-cart-integrity-status';
      status.dataset.lmbCartIntegrityStatus = 'true';
      status.setAttribute('role', 'alert');
      var target = scope.querySelector('[name="checkout"]') || scope.firstElementChild;
      if (target) target.before(status); else scope.append(status);
    }
    status.replaceChildren();
    var text = document.createElement('p');
    text.textContent = message;
    status.append(text);
    if (issue && !issue.ambiguous.length && (issue.orphaned.length || issue.mismatched.length)) {
      var repair = document.createElement('button');
      repair.type = 'button';
      repair.textContent = issue.orphaned.length && !issue.mismatched.length ? strings.remove : strings.update;
      repair.addEventListener('click', function () { repairCart(repair, status); });
      status.append(repair);
    }
    if (trigger) status.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  async function getCart() {
    var response = await fetch(routeRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(strings.unavailable);
    var cart = await response.json();
    analyse(cart);
    return cart;
  }

  async function repairCart(button, status) {
    if (busy) return;
    busy = true;
    button.disabled = true;
    try {
      var cart = await getCart();
      var issue = analyse(cart);
      if (issue.ambiguous.length) throw new Error(strings.unavailable);
      var updates = {};
      issue.orphaned.forEach(function (item) { updates[item.key] = 0; });
      issue.mismatched.forEach(function (entry) { updates[entry.item.key] = entry.quantity; });
      if (Object.keys(updates).length) {
        var response = await fetch(routeRoot + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
        var result = await response.json();
        if (!response.ok || result.status || result.errors) throw new Error(strings.unavailable);
      }
      if (!analyse(await getCart()).valid) throw new Error(strings.unavailable);
      window.location.reload();
    } catch (error) {
      status.querySelector('p').textContent = strings.unavailable;
      button.disabled = false;
    } finally { busy = false; }
  }

  async function check(trigger) {
    if (busy) return false;
    busy = true;
    try {
      var cart = await getCart();
      var issue = analyse(cart);
      if (!issue.valid) {
        showProblem(issue.samples > maxSamples ? strings.sampleLimit : (issue.orphaned.length ? strings.missingBed : (issue.ambiguous.length ? strings.unavailable : strings.quantity)), issue, trigger);
        return false;
      }
      if (!cart.items.length) { showProblem(strings.empty, null, trigger); return false; }
      controls(false);
      document.querySelectorAll('[data-lmb-cart-integrity-status]').forEach(function (node) { node.remove(); });
      return true;
    } catch (error) {
      showProblem(strings.unavailable, null, trigger);
      return false;
    } finally { busy = false; }
  }

  function checkoutTarget(target) {
    var button = target.closest('button[name="checkout"], input[type="submit"][name="checkout"]');
    if (button) return button;
    var link = target.closest('a[href]');
    if (!link) return null;
    var url = new URL(link.href, window.location.href);
    return url.origin === window.location.origin && /^\/checkout(?:[/?]|$)/.test(url.pathname) ? link : null;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var target = checkoutTarget(event.target);
    if (!target) return;
    if (approvedClicks.has(target)) { approvedClicks.delete(target); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    check(target).then(function (valid) {
      if (!valid || !target.isConnected) return;
      approvedClicks.add(target);
      if (target.form) approvedForms.add(target.form);
      target.click();
      approvedForms.delete(target.form);
      approvedClicks.delete(target);
    });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var url = new URL(form.action, window.location.href);
    if (url.origin !== window.location.origin || (!/^\/checkout(?:[/?]|$)/.test(url.pathname) && event.submitter?.name !== 'checkout')) return;
    if (approvedForms.has(form)) { approvedForms.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    check(event.submitter).then(function (valid) {
      if (!valid || !form.isConnected) return;
      approvedForms.add(form);
      form.requestSubmit(event.submitter || undefined);
      approvedForms.delete(form);
    });
  }, true);

  installSampleLimit();
  window.LmbCartIntegrity = { analyse: analyse, check: check, sampleCount: sampleCount, projectSampleCart: projectSampleCart, maxSamples: maxSamples };
  var initialIssue = analyse({ items: config.items });
  if (!initialIssue.valid) showProblem(initialIssue.samples > maxSamples ? strings.sampleLimit : (initialIssue.orphaned.length ? strings.missingBed : strings.quantity), initialIssue);
})();
